import React from "react";
import { useTranslation } from "react-i18next";

import { Identifiable, Comment } from "@planzone/dto";
import { useRetrieveProjectLogs } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Loader } from "@common/loader";
import { Log } from "./log";
import { Export } from "./export";
import { Props } from "./types";
import styles from "./styles.scss";

function logsToString(t: any, logs: Identifiable<Comment>[]): string {
  return logs
    .map((log) => {
      const submissionDate = new Date(log.createdDate);
      return `${t(`log.${log.content}`, {
        author: log.author.name,
      })} ${log.attributes?.path}${
        log.attributes?.name
      } ${submissionDate.toLocaleDateString()} ${submissionDate.getHours()}h${submissionDate
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
    })
    .join("\n");
}

function ProjectLogs({ projectId, close }: Props) {
  const { t } = useTranslation();
  const {
    retrieveProjectLogs,
    logs,
    isRequestSuccess,
    isRequestPending,
    isRequestFailure,
  } = useRetrieveProjectLogs(projectId);

  React.useEffect(() => {
    retrieveProjectLogs(projectId);
  }, []);

  return (
    <Modal
      className={styles.projectLogs}
      header={t("projectLogs.title")}
      close={close}
    >
      <div className={styles.content}>
        {isRequestPending ? (
          <div className={styles.loader}>
            <Loader />
          </div>
        ) : (
          <div className={styles.body}>
            <Export data={logsToString(t, logs)} />
            <div className={styles.logs}>
              {logs.map((log) => (
                <Log key={log.uuid} log={log} />
              ))}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export { ProjectLogs };
